'use client';

import Link from '@eliadmin/core/src/components/link';

import { useEffect } from 'react';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogTitle,
} from '@eliadmin/core/src/components/ui/alert-dialog';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function EventSubscriptionDialog() {
  const me = useCustomerStore(s => s.me);
  const subscribed = me?.customer?.active_subscriptions?.length ? true : false;

  const { isOpen, close, open } = useDisclosure();
  const { t } = useTranslations();

  useEffect(() => {
    const hasSeen = document.cookie.includes('subscription_dialog_shown=true');
    if (!hasSeen && !subscribed && me) {
      open();
      document.cookie = 'subscription_dialog_shown=true; max-age=31536000; path=/';
    }
  }, [open]);

  const handleClose = () => {
    close();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleClose}>
      <AlertDialogContent
        className={cn(
          'flex w-full flex-col items-start justify-start gap-10 rounded-none border border-border bg-white p-6 sm:max-w-[760px] sm:gap-12 sm:p-8 lg:gap-16 lg:p-12',
          'ea-event-subscription-dialog__content',
        )}
      >
        <AlertDialogTitle hidden>{t('text3122')}</AlertDialogTitle>
        <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-6">
          <h4
            className={cn(
              'font-heading font-bold',
              'text-2xl text-foreground sm:text-3xl lg:text-4xl',
            )}
          >
            {t('text3122')}
          </h4>
          <p className="w-full text-base text-black/70 sm:text-lg lg:text-xl">{t('text3123')}</p>
        </div>
        <div className="flex w-full flex-col items-start justify-start gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <AlertDialogCancel
            asChild
            className="bg-primary text-black hover:bg-primary/90 hover:text-black"
          >
            <Button asChild className="w-full sm:w-fit">
              <Link prefetch={false} href={ROUTES.SUBSCRIPTION()}>
                {t('text3124')}
              </Link>
            </Button>
          </AlertDialogCancel>
          <AlertDialogCancel
            asChild
            className="border-none bg-black text-white hover:bg-black/90 hover:text-white"
          >
            <Button variant={'dark'} className="w-full sm:w-fit">
              {t('text272')}
            </Button>
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
